export enum GifActions {
    ADD_GIF = 'ADD_GIF',
    UPDATE_GIF = 'UPDATE_GIF',
    DELETE_GIF = 'DELETE_GIF',
    GIF_ERROR = 'GIF_ERROR',
    ADD_FAVORITE = 'ADD_FAVORITE',
    DELETE_FAVORITE = 'DELETE_FAVORITE',
    GET_GIF = 'GET_GIF',
    GET_GIFS = 'GET_GIFS',
    SEARCH = 'SEARCH'
}



// WEBPACK FOOTER //
// ./src/constants/gifActions.ts